import {Tooltip} from 'platform/components';
import {Image} from 'platform/foundation';

import {CellRendererProps} from '../../types/CellRendererProps';
import {getTooltipProps} from '../../utils/getTooltipProps';
import {EmptyCellValue} from '../EmptyCellValue/EmptyCellValue';

// thumbnailHeightPx is pre-computed in GridCell as rowHeightPx - verticalPaddingPx.
// This avoids a per-cell store subscription — the computation lives in GridRow
// (1 subscription per row) and is threaded down via renderCell.
type ThumbnailCellRendererProps = CellRendererProps<string | null> & {
  thumbnailHeightPx: number;
};

export function ThumbnailCellRenderer(props: ThumbnailCellRendererProps) {
  const tooltipProps = getTooltipProps(props.row);

  if (!props.value) {
    return <EmptyCellValue emptyCellValue={props.emptyCellValue} isWrap={props.isWrap} />;
  }

  const imageHeightCss = `calc(${props.thumbnailHeightPx}px)` as const;
  const src = `${props.value}&height=${props.thumbnailHeightPx}`;

  return (
    <div className="flex items-center [&_img]:rounded">
      <Tooltip
        {...tooltipProps}
        isDisabled={false}
        label={<Image fit="contain" src={`${props.value}&height=500`} />}
      >
        {/* Plain <img> instead of platform Image: the latter starts each mount
            with isLoading=true and only flips to false in onLoad, so even
            browser-cached images flash through an opacity transition every time
            a previously-viewed page is re-rendered. A bare <img> lets the
            browser's HTTP cache present the picture instantly. */}
        <img
          alt=""
          src={src}
          height={props.thumbnailHeightPx}
          loading="lazy"
          style={{height: imageHeightCss, objectFit: 'contain'}}
        />
      </Tooltip>
    </div>
  );
}
